import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Table, Container, Icon, Popup, Button, Dropdown, Form, Loader} from 'semantic-ui-react';
// import DatePicker from 'react-datepicker';
import axios from 'axios';
import {formatDate, options} from '../Utility/helpers';

import {LOCAL_ENDPOINTS} from '../config';
import './Constants.css';

class MainPage extends Component {
  constructor(props){
    super(props)
    this.state = {
      tenants_from_xero: [],
      export_options: [],
      start_date: formatDate(new Date()),
      end_date: formatDate(new Date()),
      network_state: true,
      access_token: localStorage.getItem("access_token")
    }
    this.fetchTenants = this.fetchTenants.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleExportOptions = this.handleExportOptions.bind(this);
  }

  componentDidMount = async () => {
    const tenants_from_xero = await this.fetchTenants(this.state.access_token)
    this.setState({tenants_from_xero})
  }

  //@ Returns tenants from the application
  fetchTenants = (access_token) => {
    if(!this.state.network_state) return [];
    return axios({
      method: "GET",
      url: LOCAL_ENDPOINTS.getConnections,
      headers: {"Authorization": "Bearer " + access_token, "Content-Type": "application/json"},
    })
    .then(result => {
      return result.data;
    })
    .then(tenants => {
      return tenants.map(async tenant => {
        // console.log(tenant);
        let organisation = await axios({method: "GET", url: LOCAL_ENDPOINTS.getOrganisationName, headers: {"Authorization": "Bearer " + access_token, "Xero-tenant-id": tenant.tenantId}})
        return {
          tenantId: tenant.tenantId,
          tenantType: tenant.tenantType,
          organisationName: organisation.data.Organisations[0].LegalName
        }
      })
    })
    .then(result => {
      return Promise.all(result)
    })
  }

  handleChange = e =>{
    const target = e.target;
    const value = (target.value);
    const name = target.name;

    this.setState({
        [name]: value
    });
  }
  
  handleExportOptions = (e, data) => {
    this.setState({
      export_options: data.value
    })
  }

  downloadCSV = () => {
    const {access_token} = this.state;
    let {tenants_from_xero, start_date, end_date, export_options} = this.state;

    start_date = new Date(start_date);
    end_date = new Date(end_date);

    if(export_options.length === 0){
      alert("Input export options first!");
    }else{
      if(start_date < end_date){
        let unencoded = `Date >= DateTime(${start_date.getFullYear()}, ${start_date.getMonth()+1}, ${start_date.getDate()}) && Date < DateTime(${end_date.getFullYear()}, ${end_date.getMonth()+1}, ${end_date.getDate()})`
        let date_params = encodeURIComponent(unencoded)
        
        export_options.map(async option => {
          await axios({
            method: "POST",
            url: LOCAL_ENDPOINTS[option],
            headers: {"Authorization": "Bearer " + access_token},
            data: {
              date_params,
              tenants_from_xero,
            }
          })
        })
      }else{
        alert("Start date cannot be further than end date!")
      }
    }
  }

  render(){
    const {tenants_from_xero, network_state} = this.state;
    let tenant_builder;

    if(!network_state){
      tenant_builder = <Table.Row><Table.HeaderCell colSpan="4"> <p className="active-loader">Cannot connect to API. Contact your administrator</p> </Table.HeaderCell></Table.Row>
    }else{
      if(!tenants_from_xero){
        tenant_builder = <Table.Row><Table.Cell> No results </Table.Cell></Table.Row>
      }else{
        tenant_builder = (tenants_from_xero.length === 0)?
          <Table.Row>
            <Table.Cell colSpan="4">
              <div>
                <Loader active inline="centered">Loading data</Loader>
              </div>
            </Table.Cell>
          </Table.Row>:
           tenants_from_xero.map(tenant => {
            return(
              <Table.Row key={tenant.tenantId}>
                <Table.Cell>{tenant.tenantId}</Table.Cell>
                <Table.Cell>{tenant.organisationName}</Table.Cell>
                <Table.Cell>{tenant.tenantType}</Table.Cell>
                <Table.Cell>
                  <Popup content="View tenant" trigger = {<Link to={"/tenant/" +tenant.tenantId}><Icon name="eye"/></Link>}></Popup>
                </Table.Cell>
              </Table.Row>
            )
          })
      }
    }
    
    return(
      <div>
        <div>
          <Container>
            <div className="organisation-title">
              <h2>Your Organisations</h2>
              <p>Organisations connected post-authorization are listed here.</p>
              <p>Organisations created or linked to your account are viable to be connected here.</p>
            </div>
          
            <div className="export-settings">
              <Dropdown placeholder="Select data to export" fluid multiple selection options={options} value={this.state.export_options} onChange={this.handleExportOptions}></Dropdown>
              <div className="export-filters">

                <div>
                  <Form.Input type="Date" label="Start date" value={this.state.start_date} onChange={this.handleChange} name="start_date"></Form.Input>
                </div>
                <div>
                  <Form.Input type="Date" label="End date" value={this.state.end_date} onChange={this.handleChange} name="end_date"></Form.Input>
                </div>
                <div>
                  <Button className="export-button" color="green" onClick={this.downloadCSV}>EXPORT</Button>
                </div>
              </div>
            </div>

            <div className="tenant-table">
              <Table celled size="small" striped>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Tenant ID</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Type</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {tenant_builder}
                </Table.Body>
             </Table>
           </div>
          </Container>
        </div>
      </div>
    )
  }
}

export default MainPage;